import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-lamp.svg'


const _hoisted_1 = {
  key: 0,
  class: "content-instructions"
}
const _hoisted_2 = { class: "content-text" }
const _hoisted_3 = { class: "text-instructions bold" }
const _hoisted_4 = { class: "text-instructions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isDesktop)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "content-logo" }, [
          _createElementVNode("img", {
            class: "icon-lamp",
            src: _imports_0
          })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString($setup.props.instructions.title) + " ", 1),
          _createElementVNode("span", _hoisted_4, _toDisplayString($setup.props.instructions.description), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}